import React, { Component } from 'react';

class RadioTab extends Component {
    render() {
        const radioInputName = this.props.radioInputName;
        const dataLabel = this.props.dataOption;
        const checkedValue = this.props.defaultCheck;

        return (
            <div className={`
                text-gray-400 font-medium select-none
                ${this.props.disabled ? "radio-tab-disabled" : "radio-tab"}
            `}>
                {dataLabel.map((data, index) => {
                    return (
                        <label key={`${radioInputName}${index}`}>
                            <input
                                id={this.props.id}
                                type="radio"
                                name={radioInputName}
                                value={data.value}
                                className="hidden"
                                checked={data.value === checkedValue}
                                onChange={this.props.onChange}
                                disabled={this.props.disabled}
                            />
                            <div className={`px-5 py-2 ${this.props.disabled ? "" : "cursor-pointer"}`}>
                                {data.label}
                            </div>
                        </label>
                    );
                })}
            </div>
        );
    }
}

export default RadioTab;
